import {
  Form,
  onFieldInputValueChange,
  onFieldReact
} from '@eastcoal/formily/exports/core'

import { AnnouncementType } from '@eastcoal/shared/enums/AnnouncementType'

import {
  ANNOUNCEMENT_FIELD,
  KIND_FIELD,
  MEMBER_FIELD
} from '../constants/field'

/**
 * “竞价预告”联动逻辑
 */
const updateState = (_: unknown, form: Form) => {
  const { memberId, kindIds } = form.values
  const disabled = !(memberId && kindIds) || !form.editable
  form.setFieldState(ANNOUNCEMENT_FIELD, state => {
    state.disabled = disabled
    state.componentProps = {
      readyRequest: !disabled,
      memberId: memberId,
      kindId: kindIds,
      type: AnnouncementType.APPLY
    }
  })
}

const clearValue = (_: unknown, form: Form) => {
  form.setFieldState(ANNOUNCEMENT_FIELD, state => {
    state.value = null
  })
}

export const announcementEffect = () => {
  onFieldReact(MEMBER_FIELD, updateState)
  onFieldReact(KIND_FIELD, updateState)
  onFieldInputValueChange(MEMBER_FIELD, clearValue)
  onFieldInputValueChange(KIND_FIELD, clearValue)
}
